import { Box } from '@mui/material';
import React from 'react';
import { themeColors } from '../../JuvareTheme';
/**
 * A layout wrapper that displays children inside a dashed border box.
 * It adapts its layout direction and alignment based on screen size.
 *
 * @param {object} root0 - Props object.
 * @param {React.ReactNode} root0.children - Elements to render inside the wrapper.
 *
 * @returns {JSX.Element} The styled wrapper component with dashed border.
 */
export const DashedWrapper = ({ children }) => {
    return (React.createElement(Box, { sx: {
            display: 'flex',
            flexDirection: { xs: 'column', lg: 'row' },
            alignItems: 'center',
            justifyContent: { xs: 'center', lg: 'unset' },
            width: '100%',
            border: 'dashed',
            borderRadius: 2,
            borderColor: themeColors.border.main,
            backgroundColor: themeColors.surface.primary,
        }, "data-test": 'empty-content-wrapper' }, children));
};
